import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMotorolaComponent } from './simple-icons-motorola.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMotorolaComponent ],
    exports:      [ SimpleIconsMotorolaComponent ],
    bootstrap:    []
})
export class SimpleIconsMotorolaModule {}
